module.exports = __webpack_public_path__ + "static/media/State-of-the-art.1bf55931.png";